<template>
  <div class="container-fluid">
    <Breadcrumb :values="{ Home: '/', Users: '' }"></Breadcrumb>
    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-edit"></i>
            Users
          </div>
          <router-link
            class="nav-link p-0"
            :to="{name: 'add-user'}">
            <div
                class='btn btn-primary pull-right d-flex justify-content-center align-items-center'
                style="margin: 0"
            >
              <font-awesome-icon class="mr-1" style="font-size: 0.7rem" icon="plus"></font-awesome-icon> Create
            </div>
          </router-link>
        </div>
        <div class="card-body">
          <div class="remove-user-popup modal-background fade" :class="{ show: deleteModal.visible }"></div>
          <div class="modal fade" :class="{ show: deleteModal.visible }" style="display: block;">
            <div class="modal-dialog modal-danger" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Confirm user removal</h4>
                  <button class="close" type="button" aria-label="Close" @click="hideDeleteModal"><span
                      aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                  <p>Are you sure you want to remove user "{{ `${deleteModal.userData.firstname} ${deleteModal.userData.lastname}` }}"?</p>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-secondary" type="button" data-dismiss="modal" @click="hideDeleteModal">Close</button>
                  <button class="btn btn-danger" type="button" @click="[hideDeleteModal(), deleteSelectedUser(deleteModal.userData)]">Remove</button>
                </div>
              </div>
            </div>
          </div>
          <div class="dataTables_wrapper container dt-bootstrap4 no-footer">
            <div class="row mb-1">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length" >
                  <label>Show
                    <select
                        class="form-control form-control-sm"
                        v-model="perPage"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter">
                  <label>Search:
                    <input
                      type="search"
                      class="form-control form-control-sm"
                      placeholder=""
                      v-model="searchValue"
                      @keyup="searchTimeout"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <table class="table table-striped table-bordered datatable dataTable no-footer"
                       role="grid"
                >
                  <thead>
                  <tr role="row">
                    <th class="sorting_asc" style="width: 288px;">Username
                    </th>
                    <th class="sorting">Date registered
                    </th>
                    <th class="sorting">Last seen
                    </th>
                    <th class="sorting" style="width: 120px;">Role
                    </th>
                    <th class="sorting">Status
                    </th>
                    <th class="sorting" style="min-width: 160px;">Actions
                    </th>
                  </tr>
                  </thead>
                  <tbody v-if="users.length">
                  <tr role="row" v-for="(user,index) in users" :key="`user-${index}`" :class="index/2 === 0 ? 'even' : 'odd'">
                    <td class="sorting_1">{{ `${user.firstname} ${user.lastname}` }}</td>
                    <td>{{ moment(new Date(user.created_at)).format('l') }}</td>
                    <td>{{ moment(new Date(user.last_seen)).format('l') }}</td>
                    <td>{{ user.role.name }}</td>
                    <td v-if="user.status === 'enabled'">
                      <span class="badge badge-success">{{ user.status }}</span>
                    </td>
                    <td v-else-if="user.status === 'disabled'">
                      <span class="badge badge-success">{{ user.status }}</span>
                    </td>
                    <td>
                      <router-link :to="{path: `/users/${user.id}/`}">
                        <div class="btn btn-success">
                          <div class="icon-wrapper">
                            <font-awesome-icon icon="search" style="font-size: 10px"></font-awesome-icon>
                          </div>
                        </div>
                      </router-link>
                      <router-link :to="{path: `/users/${user.id}/edit/`}" class="ml-1">
                        <div class="btn btn-primary">
                          <div class="icon-wrapper">
                            <font-awesome-icon icon="edit" style="font-size: 10px"></font-awesome-icon>
                          </div>
                        </div>
                      </router-link>
                      <a class="btn btn-danger ml-1" @click="showDeleteModal(user)">
                        <div class="icon-wrapper">
                          <font-awesome-icon icon="trash-alt" color="white" style="font-size: 10px"></font-awesome-icon>
                        </div>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr>
                    <td colspan="5">
                      No data
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-3">
                <div class="dataTables_info" role="status">
                  {{getTotalUsersText}}
                </div>
              </div>
              <div class="col-sm-12 col-md-9">
                <div class="dataTables_paginate paging_simple_numbers">
                  <ul class="pagination">
                    <li
                        class="paginate_button page-item previous"
                        :class="{ disabled: !parsedPagination.hasPrev}"
                    >
                      <a
                          @click="paginatedUsers(parsedPagination.page - 1, perPage, searchValue)">
                        Previous
                      </a>
                    </li>
                    <li v-for="page in preparePages" :key="`page-${page}`" class="paginate_button page-item"
                        :class="page === parsedPagination.page ? 'active' : ''">
                      <a
                          @click="!['...','..'].includes(page) ? paginatedUsers(page, perPage, searchValue) : []"
                          class="page-link">
                        {{ page }}
                      </a>
                    </li>
                    <li class="paginate_button page-item next"
                        :class="{ disabled: !parsedPagination.hasNext }"
                    >
                      <a @click="paginatedUsers(parsedPagination.page + 1, perPage, searchValue)">
                        Next
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import usersActions from '../store/modules/users/actionTypes'
import usersGetters from '../store/modules/users/getterTypes'
import Breadcrumb from '../components/shared/Breadcrumb'
import generalActions from '../store/modules/general/actionTypes'

export default {
  name: 'UserList',
  components: { Breadcrumb },
  data () {
    return {
      perPage: 10,
      searchValue: '',
      deleteModal: {
        visible: false,
        userData: {}
      },
      searchTimer: null
    }
  },
  computed: {
    ...mapGetters({
      users: usersGetters.GET_USERS,
      pagination: usersGetters.GET_PAGINATION
    }),
    parsedPagination () {
      return {
        'perPage': this.pagination['x-pagination-per_page'],
        'total': this.pagination['x-pagination-total'],
        'page': parseInt(this.pagination['x-pagination-page']),
        'hasPrev': this.pagination['x-pagination-has_prev'] === 'True',
        'pages': parseInt(this.pagination['x-pagination-pages']),
        'hasNext': this.pagination['x-pagination-has_next'] === 'True'
      }
    },
    getTotalUsersText () {
      const currentAmount = (this.parsedPagination.page - 1) * this.parsedPagination.perPage + 1
      const totalAmount = this.parsedPagination.hasNext ? this.parsedPagination.page * this.parsedPagination.perPage : this.parsedPagination.total
      return `Showing ${currentAmount} to ${totalAmount} of ${this.parsedPagination.total} entries`
    },
    preparePages () {
      let currentPages = 0
      const pages = this.parsedPagination.pages
      const page = this.parsedPagination.page
      if (this.parsedPagination.pages < 11) {
        currentPages = this.parsedPagination.pages
      } else {
        if (page < 6) {
          currentPages = this.pageRange(1, 8, 1).concat(['..', this.parsedPagination.pages])
        } else if (page + 6 > pages) {
          currentPages = [1, '...'].concat(this.pageRange(pages - 7, pages, 1))
        } else {
          currentPages = [1, '...'].concat(this.pageRange(page - 3, page + 3, 1)).concat(['..', pages])
        }
      }
      return currentPages
    }
  },
  methods: {
    ...mapActions({
      getUsers: usersActions.FETCH_USERS,
      getRoles: usersActions.FETCH_ROLES,
      getPaginatedUsers: usersActions.FETCH_PAGINATED_USERS,
      toggleLoading: generalActions.TOGGLE_LOADING,
      deleteUser: usersActions.DELETE_USER
    }),
    parseDate (date) {
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    async deleteSelectedUser (user) {
      let data = { ...user }
      data.deleted = true
      const response = await this.deleteUser(data)
      if (response.status === 200) {
        this.getPaginatedUsers({
          page: this.parsedPagination.page,
          perPage: this.perPage,
          searchQuery: this.searchValue })
      } else {
        console.error(response)
      }
    },
    showDeleteModal (user) {
      this.deleteModal.visible = true
      this.deleteModal.userData = user
    },
    hideDeleteModal () {
      setTimeout(() => this.deleteModal.userData = {}, 300)
      this.deleteModal.visible = false
    },
    pageRange (start, stop, step) {
      let a = [start]; let b = start
      while (b < stop) {
        a.push(b += step || 1)
      }
      return a
    },
    searchTimeout () {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
      this.searchTimer = setTimeout(() => {
        this.getPaginatedUsers({
          page: 1,
          perPage: this.perPage,
          searchQuery: this.searchValue
        })
      }, 800)
    },
    paginatedUsers (page, perPage, searchValue = '') {
      this.toggleLoading(true)
      if (searchValue !== '') {
        this.getPaginatedUsers({
          page: page,
          perPage: perPage,
          searchQuery: searchValue
        })
      } else {
        this.getPaginatedUsers({ page: page, perPage: perPage })
      }
      this.toggleLoading(false)
    }
  },
  watch: {
    perPage (newData) {
      if (this.searchValue !== '') {
        this.getPaginatedUsers({
          page: 1,
          perPage: newData,
          searchQuery: this.searchValue
        })
      } else {
        this.getPaginatedUsers({ page: 1, perPage: newData })
      }
    }
  },
  async beforeMount () {
    this.toggleLoading(true)
    await this.getUsers()
    this.toggleLoading(false)
  }
}

</script>
<style scoped>
.remove-user-popup {
  z-index: -1
}
.modal-background {
  background-color: rgba(0, 0, 0, 0.35);
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}
.modal {
  z-index: -1;
}
.btn {
  cursor: pointer;
}
.paginate_button {
  cursor: pointer;
}
.icon-wrapper {
  width: 10px;
  height: 10px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  margin-top: 6px !important;
  margin-bottom: 6px;
}
.card-body .show {
  z-index: 1200;
}
.card-header {
  height: 59px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.paging_simple_numbers {
  float: right;
}

.dataTables_length {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.dataTables_filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.dataTables_length label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.dataTables_filter label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 355px;
}

.dataTables_length label select {
  width: 50px;
  margin: 0 5px;
}

.dataTables_filter label input {
  width: 300px;
  margin-left: 5px;
}

ul {
  display: flex;
  flex-wrap: wrap;
}

</style>
